import React from "react";
import PropTypes from "prop-types";

import { Radio } from "antd";

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const defaultProps = {
  value: null,
};

function YesOrNoInput(props) {
  return (
    <Radio.Group buttonStyle="solid" {...props}>
      <Radio.Button value>Да</Radio.Button>
      <Radio.Button value={false}>Нет</Radio.Button>
    </Radio.Group>
  );
}

YesOrNoInput.propTypes = propTypes;
YesOrNoInput.defaultProps = defaultProps;

export default YesOrNoInput;
